// @flow
import React from 'react'
import {setCombatantValue} from '../../../redux-actions/battle-actions.js'
import {handleAnimationEnd, timeout} from './animation-lifecycle-utilities'
import audioManager from '../../../_audio/audio-manager.js'

class AnimationTeamForEach extends React.Component {

  props: {
    casterId: string,
    targetIds: Array<string>,
    targetsDamageTracker: Object
  };

  /** Make the target wiggle (called once per iteration) */
  async runIterationAnimation(subject:Object, callback:Function) {

    //Play SFX per iteration!
    audioManager.playSfx("sfx_loopIterate");

    //Shake the caster
    setCombatantValue(subject.combatantId, {
      animationCssRule: "shake 0.4s infinite"
    });

    /* ----------- */ await timeout(300);

    //Stop shaking caster
    setCombatantValue(subject.combatantId, {
      animationCssRule: "none"
    });

    /* ----------- */ await timeout(150);

    callback();
  }

  //recursive! Run this step, then call self again with the next step
  runStep(index:number, series:Array<Object>) {
    if (series[index]) {

      return this.runIterationAnimation(series[index], () => {
        this.runStep(index+1, series);
      });

    } else {
      //Series is complete!

      //Stop shaking caster
      setCombatantValue(this.props.casterId, {
        animationCssRule: "none"
      });

      //We've gotten through all of the steps of `series` array. Now fire the "final done" call!
      handleAnimationEnd()
    }
  }

  componentDidMount() {

    //targetsDamageTracker provides us the data of who got hit, and in what order
    //Sort the damage tracker's steps by order.
    const tracker = this.props.targetsDamageTracker;
    let allSteps = Object.keys(tracker).map(key => tracker[key]).reduce((a,b) => {
      return [...a, ...b]
    }).sort((a,b) => {
      return a.order > b.order ? 1 : -1
    });

    //Start shaking the Caster. Will stop when we're done
    setCombatantValue(this.props.casterId, {
      animationCssRule: "tada 0.5s infinite"
    });

    //Kick off our first step!
    setTimeout( () => {
      this.runStep(0, allSteps);
    }, 200) //pause for effect. This is a big move!

  }

  render() {
    return null;
  }
}

export default AnimationTeamForEach;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/animation-components/AnimationTeamForEach.js